<div class="titlebar">
  <div class="media-name">{{ title }}</div>
</div>
<div class="timers">
  <div class="timer">
    <span class="time">
      {{ videoDuration ? vm.timeFormatFunction(videoDuration) : "--:--:--.---" }}
    </span>
    <span class="name">Video Duration</span>
  </div>
  <div class="timer">
    <span class="time">
      {{
        currentTime || (videoDuration && currentTime == 0)
          ? vm.timeFormatFunction(currentTime)
          : "--:--:--.---"
      }}
    </span>
    <span class="name"> Current Video Time</span>
  </div>
</div>
<div class="buttons">
  <div class="history-buttons">
    <div class="undo" (click)="vm.onHeaderButtonClicked('undo')" title="Undo">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.66128 4.53596C7.32654 4.20123 6.78391 4.20123 6.44917 4.53596L3.02059 7.96454C2.68585 8.29927 2.68585 8.84199 3.02059 9.17672L6.44917 12.6053C6.78391 12.94 7.32654 12.94 7.66128 12.6053C7.99603 12.2705 7.99603 11.7278 7.66128 11.3931L5.69602 9.42777H16.1981C18.8806 9.42777 21.0552 11.6024 21.0552 14.2849C21.0552 16.9674 18.8806 19.1421 16.1981 19.1421H8.19808C7.72471 19.1421 7.34094 19.5258 7.34094 19.9992C7.34094 20.4726 7.72471 20.8564 8.19808 20.8564H16.1981C19.8274 20.8564 22.7695 17.9142 22.7695 14.2849C22.7695 10.6556 19.8274 7.71349 16.1981 7.71349H5.69602L7.66128 5.74815C7.99603 5.41341 7.99603 4.87069 7.66128 4.53596Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
    <div class="redo" (click)="vm.onHeaderButtonClicked('redo')" title="Redo">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.8778 4.53596C18.2125 4.20123 18.7552 4.20123 19.0899 4.53596L22.5185 7.96454C22.8532 8.29927 22.8532 8.84199 22.5185 9.17672L19.0899 12.6053C18.7552 12.94 18.2125 12.94 17.8778 12.6053C17.543 12.2705 17.543 11.7278 17.8778 11.3931L19.843 9.42777H9.34098C6.65845 9.42777 4.48382 11.6024 4.48382 14.2849C4.48382 16.9674 6.65844 19.1421 9.34097 19.1421H17.341C17.8144 19.1421 18.1981 19.5258 18.1981 19.9992C18.1981 20.4726 17.8144 20.8564 17.341 20.8564H9.34097C5.71166 20.8564 2.76953 17.9142 2.76953 14.2849C2.76953 10.6556 5.71167 7.71349 9.34098 7.71349H19.843L17.8778 5.74815C17.543 5.41341 17.543 4.87069 17.8778 4.53596Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
    <div
      class="debug"
      [class.active]="vm.showDebugPanel"
      (click)="vm.showDebugPanel = !vm.showDebugPanel"
      title="VOD Debug Panel"
    >
      <svg
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 8h-2.81a5.985 5.985 0 0 0-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
    <div
      class="settings"
      (click)="vm.onHeaderButtonClicked('settings')"
      title="Settings"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M18.8766 12.9068C18.9136 12.6107 18.9414 12.3146 18.9414 12C18.9414 11.6855 18.9136 11.3894 18.8766 11.0933L20.8289 9.56664C21.0047 9.42785 21.051 9.17803 20.9399 8.97448L19.0894 5.77312C18.9784 5.56956 18.7286 5.49554 18.525 5.56956L16.2212 6.49481C15.74 6.12471 15.2219 5.81938 14.6575 5.58807L14.3059 3.13616C14.2782 2.9141 14.0839 2.74756 13.8525 2.74756H10.1515C9.92024 2.74756 9.72593 2.9141 9.69818 3.13616L9.34658 5.58807C8.78218 5.81938 8.26404 6.13397 7.78291 6.49481L5.47905 5.56956C5.26624 5.48629 5.02567 5.56956 4.91464 5.77312L3.06415 8.97448C2.94387 9.17803 2.99938 9.42785 3.17518 9.56664L5.12745 11.0933C5.09044 11.3894 5.06268 11.6947 5.06268 12C5.06268 12.3054 5.09044 12.6107 5.12745 12.9068L3.17518 14.4334C2.99938 14.5722 2.95312 14.822 3.06415 15.0256L4.91464 18.227C5.02567 18.4305 5.27549 18.5045 5.47905 18.4305L7.78291 17.5053C8.26404 17.8754 8.78218 18.1807 9.34658 18.412L9.69818 20.8639C9.72593 21.086 9.92024 21.2525 10.1515 21.2525H13.8525C14.0839 21.2525 14.2782 21.086 14.3059 20.8639L14.6575 18.412C15.2219 18.1807 15.74 17.8661 16.2212 17.5053L18.525 18.4305C18.7378 18.5138 18.9784 18.4305 19.0894 18.227L20.9399 15.0256C21.051 14.822 21.0047 14.5722 20.8289 14.4334L18.8766 12.9068ZM12.002 15.2384C10.2163 15.2384 8.76368 13.7858 8.76368 12C8.76368 10.2143 10.2163 8.76167 12.002 8.76167C13.7878 8.76167 15.2404 10.2143 15.2404 12C15.2404 13.7858 13.7878 15.2384 12.002 15.2384Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
  </div>
  <svg
    class="divider"
    width="2"
    height="40"
    viewBox="0 0 2 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.769531 0.570068L0.76953 38.5701"
      stroke="black"
      stroke-opacity="0.1"
      stroke-linecap="round"
    />
  </svg>
  <div class="action-buttons">
    <div class="clear-button" (click)="vm.onHeaderButtonClicked('clear')">
      <div class="transparent-outlined">cancel</div>
    </div>

    <div class="save-buttons">
      <div (click)="vm.onHeaderButtonClicked('save')">
        <div class="fill-outlined">save changes</div>
      </div>
      <div (click)="vm.onHeaderButtonClicked('render')">
        <div class="fill-outlined">render &amp; exit</div>
      </div>
    </div>
  </div>
</div>
